// import { http_v2 } from '@api/client';
import { http, http_v2 } from '@api/client';
import { pickResponse, pickResult, paramterize } from '@api/utils';
import { ContentDetail } from '@lib/content';
import {
  PersonMediaFilterParams,
  FilterResponse,
  SearchContentResponse,
  ContentResult,
  SearchContentQuery,
  ContentSearchResult,
  FilterCastCrewResponse,
} from './content-api.types';
import { of } from 'rxjs';
import { BaseResponse } from '@api/shared';
import { tap } from 'rxjs/operators';
import { PersonResequenceMedia } from '@lib/person-management';
/**
 * Create a new content on CMDB.
 * @param content The content body to create
 */
export function create(content) {
  return http.post(`/media/person`, content).pipe(pickResponse());
}
export function search(query: SearchContentQuery, vtr_id: number) {
  const params = paramterize(query);
  return http_v2
    .get<SearchContentResponse>(`/content/search/${vtr_id}`, {
      params,
    })
    .pipe(pickResponse());
}
/**
 * Get the deal details from the server.
 * @param vtr_id The id of the deal to get
 */
export function get(vtr_id: string) {
  return http_v2.get<ContentResult>(`/content/${vtr_id}`).pipe(pickResult());
  // return of(singleDealResponse);
}
/**
 * Merge deals.
 * @param data The merge request model.
 */
// export function merge(data: ContentDetail) {
//   return http_v2.put<BaseResponse<ContentDetail>>('/content/related', data).pipe(pickResponse());
// }
/**
 * Deletes the given deal.
 * @param content The deal id or the actual deal.
 */
export function remove(vtr_id: string) {
  return http
    .delete(`/media/person/${vtr_id}`).pipe(pickResponse());
}
/**
 * Updates the given deal.
 * @param content The deal to update
 */
export function update(content) {
  return http.put(`/media/person/${content?.vtr_id}`, content).pipe(pickResponse());
}
/**
 * Filter companies using dynamic operators.
 * @param option Query options
 */
export function filter({
  filters = [],
  pageSize: page_size = 10,
  page = 1,
  sortBy = [],
}: PersonMediaFilterParams = {}) {
  const isContentSort = (key: string) =>
    ['release_date', 'runtime', 'deal_count', 'vote_average'].includes(key);

  const sort = sortBy
    .filter(({ id }) => !isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const sort_content_card = sortBy
    .filter(({ id }) => isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const newFilters = filters; //updateFiltersForLinkedOperator(filters);
  const filtersMap: Record<string, string> = newFilters.reduce(
    (map, f) =>
      Object.assign(map, {
        [f.id]: Object.entries(f.value)
          .map(([op, v]) => {
            return op === '$bw'
              ? `$gte|||${v[0]};$lte|||${v[1]}`
              : op === '$in' && f.id === 'service_provided_id'
              ? `$in|||${v
                  .split(',')
                  .map(v => v.split('|||')[0])
                  .join(',')}`
              : `${op}|||${(v || '').trim()}`;
          })
          .join(';'),
      }),
    {}
  );

  const params = paramterize({ page_size, page, sort, sort_content_card, ...filtersMap });
  
  return http.get<FilterResponse>('/media/person', { params }).pipe(pickResponse());
}

export function filter_compact({
  filters = [],
  pageSize: page_size = 10,
  page = 1,
  sortBy = [],
}: PersonMediaFilterParams = {}) {
  const isContentSort = (key: string) =>
    ['release_date', 'runtime', 'deal_count', 'vote_average'].includes(key);

  const sort = sortBy
    .filter(({ id }) => !isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const sort_content_card = sortBy
    .filter(({ id }) => isContentSort(id))
    .map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`)
    .join(';');

  const newFilters = filters; //updateFiltersForLinkedOperator(filters);
  const filtersMap: Record<string, string> = newFilters.reduce(
    (map, f) =>
      Object.assign(map, {
        [f.id]: Object.entries(f.value)
          .map(([op, v]) => {
            return op === '$bw'
              ? `$gte|||${v[0]};$lte|||${v[1]}`
              : op === '$in' && f.id === 'service_provided_id'
              ? `$in|||${v
                  .split(',')
                  .map(v => v.split('|||')[0])
                  .join(',')}`
              : `${op}|||${(v || '').trim()}`;
          })
          .join(';'),
      }),
    {}
  );

  const params = paramterize({ page_size, page, sort, sort_content_card, ...filtersMap });

  return http_v2.get<FilterResponse>('/content/searches_compact', { params }).pipe(pickResponse());
}

 /** resequence media payload  */
 
 export function resequence(media: PersonResequenceMedia, id: string) {
  return http.post<any>(`/person/media_resequence/${id}`, media).pipe(pickResponse());
}